// extracted by mini-css-extract-plugin
export var progressContainer = "styles-module__progressContainer___GetZY";
export var activeProgress = "styles-module__activeProgress___Mk3TQ";